/** ルームIDとして許可する文字（DO の idFromName にそのまま渡すため制限する） */
export const ROOM_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;
export const DEFAULT_ROOM = 'lobby';

/** 未ログインでも入れるルーム。ログイン実装後は認証付きで広げる。 */
export function canJoinRoomAsGuest(roomId: string): boolean {
  return roomId === DEFAULT_ROOM;
}
